import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert"
import {
    checkModalValidationsForConfig, DIVERT_CODE_MASK,
    isValidEntry, PATTERNS, validateAddDivertConfigModal,
} from "../../../util/Validations";
import {ASL_ASSET_TYPE, CONFIG_TYPE} from "../../../util/Constants";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";

const AddAslGuidedDivertConfigurationModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {getDraftData, addInstance, editInstance} = useContext(DraftContext)

    // Visual controls
    const {open, setOpen} = props
    const [show, setShow] = useState(false)
    const [edit, setEdit] = useState(false)

    // Values
    const [divertCode, setDivertCode] = useState("")
    const [clusters, setClusters] = useState("")

    // Errors
    const [divertCodeErr, setDivertCodeErr] = useState(false)
    const [clustersErr, setClustersErr] = useState(false)

    function onCloseModal() {
        setShow(false);
        setOpen(false)
        resetInputState();
    }

    const divertConfig = {
        divertCode: divertCode,
        clusters: clusters.replace(/\s/g, '').split(';')
    }

    const divertConfigMap = {}
    getDraftData({stateKey: CONFIG_TYPE.DIVERT_CONFIGURATION, subKey: mac}).forEach((value) => {
        divertConfigMap[value.divertCode] = value.clusters;
    })

    const onClickConfirm = (divertConfig, mac) => {
        if (validateAddDivertConfigModal(divertConfig, mac, ASL_ASSET_TYPE)) {
            setConfigData();
            setOpen(false)
            resetInputState();
            setShow(false);
        } else {
            setShow(true)
        }
    }

    function resetInputState() {
        setDivertCode("");
        setDivertCodeErr(false);
        setClusters("");
        setClustersErr(false);
    }

    const prefill = () => {
        if (divertConfigMap.hasOwnProperty(divertCode)) {
            setEdit(true);
            setClusters(divertConfigMap[divertCode].join(';'));
        } else if (edit) {
            setEdit(false);
            setClusters("");
        }
    }

    const setConfigData = () => {
        if (edit) {
            editInstance({
                stateKey: CONFIG_TYPE.DIVERT_CONFIGURATION,
                subKey: mac,
                instance: divertConfig,
                keyComparator: (config1, config2) => (config1.divertCode === config2.divertCode),
                valueComparator: (config1, config2) => config1.clusters.join(';') === config2.clusters.join(';')
            })
        } else {
            addInstance({
                stateKey: CONFIG_TYPE.DIVERT_CONFIGURATION,
                subKey: mac,
                instance: divertConfig
            })
        }
    }

    return (
        <Modal
            title={formatMessage({id: "config.addupdateasl"})}
            open={open}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium">
            <Column spacing={"medium"} spacingInset={"medium"}>
                <Column spacing="200">
                    <b> <FormattedMessage id="modal.addheadingasl"
                                          defaultMessage="To edit an existing configuration, enter the same divert code again."/>
                    </b>
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary">
                        <FormattedMessage id="modal.divertcode" defaultMessage="Divert Code"/>
                    </Text>
                    <Input id="divert-code-input"
                           value={divertCode}
                           onChange={setDivertCode}
                           mask={DIVERT_CODE_MASK}
                           onBlur={() => {
                               setDivertCodeErr(!isValidEntry(divertCode, PATTERNS.DIVERT_CODE))
                               prefill();
                           }}
                           error={divertCodeErr}
                           helperText={<FormattedMessage id="modal.divertcode_desc" defaultMessage="Range: 10 to 99"/>}
                    />
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary">
                        <FormattedMessage id="modal.clusters" defaultMessage="Clusters"/>
                    </Text>
                    <Input id="cluster-input"
                           value={clusters}
                           onChange={setClusters}
                           onBlur={() => {setClustersErr(!isValidEntry(clusters, PATTERNS.CLUSTERS))}}
                           error={clustersErr}
                           helperText={<FormattedMessage id="modal.clusters_desc"
                                     defaultMessage="Separate multiple values by semicolon - e.g.: A;B;C"/>}
                    />
                </Column>
            </Column>
            <ModalFooter>
                <Column>
                    {!checkModalValidationsForConfig(divertConfig, props.mac, ASL_ASSET_TYPE) && show &&
                        <Alert type="warning" size="small">
                            <FormattedMessage id="alert.missingfields"
                                              defaultMessage="Please enter all fields in correct format!"/>
                        </Alert>}
                </Column>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary"
                            size="medium"
                            onClick={() => onClickConfirm(divertConfig, props.mac)}>
                        { edit ? <FormattedMessage id="modal.confirmUpdate" defaultMessage="Confirm update"/>
                            : <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>}
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default injectIntl(AddAslGuidedDivertConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/modal/AddAslGuidedDivertConfigurationModal.js